module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Medium.5a9bbb1e.ttf";